exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cheetah-grid__error-message-element{border-top:1px solid #ff1744;color:#ff1744}", ""]);

// exports
